import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

export const fmt = {
  money(n, digits = 2) {
    if (n == null || Number.isNaN(n)) return "—";
    return n.toLocaleString("en-US", { style: "currency", currency: "USD", minimumFractionDigits: digits, maximumFractionDigits: digits });
  },
  compact(n) {
    if (n == null || Number.isNaN(n)) return "—";
    return Intl.NumberFormat("en", { notation: "compact", maximumFractionDigits: 2 }).format(n);
  },
  pct(n, digits = 2) {
    if (n == null || Number.isNaN(n)) return "—";
    return `${n >= 0 ? "+" : ""}${n.toFixed(digits)}%`;
  },
};
